import PropTypes, { string } from 'prop-types';
// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

// SearchNotFound.propTypes = {
//   searchQuery: PropTypes.string,
//   message: string,
// };

interface SearchNotFoundProps {
  searchQuery?: string;
  message?: string;
}

export default function SearchNotFound({ searchQuery = '', message, ...other }: SearchNotFoundProps) {
  return (
    <Paper {...other} sx={{ boxShadow: 'none', py: 5 }}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {message ?? 'Not found'}
      </Typography>
      {/* <Typography variant="body2" align="center">
        No results found for &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Try checking for typos or using complete words.
      </Typography> */}
    </Paper>
  );
}
